<!--
 * @Author: 仙道
 * @Date: 2022-08-14 20:53:20
 * @LastEditTime: 2022-08-14 21:07:45
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/maintenance/overhaul/modules/LinkToDetail.vue
-->
<template>
  <a-button @click="toDetail" type="link" v-bind="$attrs">
    <slot></slot>
  </a-button>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'LinkToDetail',
    props: {
      routeName: {
        type: String,
        default: ''
      },
      id: {
        type: String,
        default: ''
      },
      record: {
        type: Object,
        default: () => { }
      }
    },
    components: {

    },
    // 定义属性
    data () {
      return {

      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      toDetail () {
        if (!this.routeName || !this.id) {
          this.$message.error('请检查跳转参数')
        }
        this.$bus.$emit('to-page-detail', {
          name: this.routeName,
          id: this.id
        })
      }
    }
  }
</script>

<style lang='scss' scoped>


</style>